module.exports = __webpack_public_path__ + "files/dc5563a728600a7f5c62fb0c01c782fd.png";